import { ContentCard } from "@narmi/design_system";
import Organization from "byzantine/src/Organization";
import { useCurrentUser } from "../../../contexts/CurrentUserContext";
import ProfileSettingRow from "../ProfileSettingRow";
import Address from "./Address/Address";
import AddressSettings from "./Address/AddressSettings";

const BusinessInfoCard = ({
  organization,
}: {
  organization?: Organization;
}) => {
  const { currentUser } = useCurrentUser();
  const primaryAddress = currentUser?.getPrimaryAddress();
  const mailingAddress = currentUser?.getMailingAddress();
  const managedOrganizations = organization?.affiliated_organizations ?? [];

  // we can update this when we add additional fields to this section
  // currently, we should hide it if there are no addresses
  if (!primaryAddress && !mailingAddress) {
    return null;
  }

  return (
    <ContentCard kind="elevated">
      <h4 className="contact-info-heading nds-sans fontSize--heading5">
        Business info
      </h4>
      <AddressSettings
        organization={organization}
        primaryAddressLabel={
          managedOrganizations.length > 0
            ? organization?.name_dba || organization?.name_legal
            : undefined
        }
      />
      {managedOrganizations.map((managedOrganization) => {
        if (!managedOrganization.address) {
          return null;
        }

        return (
          <ProfileSettingRow
            key={managedOrganization.uuid}
            label={
              managedOrganization.name_dba || managedOrganization.name_legal
            }
            value={<Address address={managedOrganization.address} />}
            isReadOnly
          />
        );
      })}
    </ContentCard>
  );
};

export default BusinessInfoCard;
